import store from "@/store";
import JwtService, {getMasterToken} from "@/common/jwt.service";
import ApiService from "@/common/api.service";
import {PURGE_AUTH, SET_AUTH, SET_ERROR} from "@/store/auth.module";

const UserService = {
    /**
     * If code is a string, just one permission, if it is an array than it's an OR between permissions.
     * @param code
     * @returns {boolean}
     */
    hasPermission: (code) => {
        if (!code) {
            return true;
        }
        let user = store.getters.currentUser;
        // console.log('user', user);
        if (!user || !user.permissions) {
            return false;
        }
        // if (code == 'super'){
        //     return false;
        // }
        if (code == 'super' && !UserService.isSuperDebugUser()) { // global permission
            return false;
        }
        if (code == 'adminextcrm' && !UserService.allowReadonlyExternalCrm() && !UserService.isSuperDebugUser()) { // global permission
            return false;
        }
        if (code == 'adminextcrmwrite' && !UserService.isSuperDebugUser()) { // global permission
            return false;
        }
        if (code == 'adminorg' && !UserService.isSuperDebugUser() && !user.is_organization_admin) { // global permission
            return false;
        }
        if ((code == 'admingrouporg' || code == 'group.create' || code == 'group.delete' || code == 'group.view') && !UserService.isSuperDebugUser() && !UserService.canManageOrganizationGroups()) { // global permission
            return false;
        }
        if (code == 'estrasfcredentials') { // org has at least one estrafs contract configuration (flag from /users/me)
            return !!user.estrasf_available;
        }

        // Blocca temporaneamente tutti da modifiche contratti
        const specialToBlock = ['contract.edit', 'contract.delete', 'contract.create'];
        if (specialToBlock.includes(code) && !UserService.isSuperDebugUser()) {
            return false;
        }
        //

        if (user.permissions.includes("*")) { // global permission
            return true;
        }
        if (Array.isArray(code)) {
            return user.permissions.filter(x => code.includes(x)).length > 0;
        } else {
            return user.permissions.includes(code);
        }
    },
    canManageOrganizationGroups: () => {
        const allowed = window.__env.allowedUserManageOrganizationGroups || [];
        return allowed.includes(store.getters.currentUser.id);
    },
    isSuperDebugUser: () => {
        return store.getters.currentUser.email == 'nicolamti@gmail.com' ||
        store.getters.currentUser.email == 'marco.palama@soloweb.io' ||
        store.getters.currentUser.email == 'andrea.gasloli@soloweb.io' ||
        store.getters.currentUser.email == 'giulia.vanzini@soloweb.io' ||
        store.getters.currentUser.email == 'marco.salatin@gmail.com' ||
        store.getters.currentUser.email == 'fabrizio.dammassa@gmail.com';
    },
    allowReadonlyExternalCrm: () => {
        let allowed = ['spanti@estraspa.it','lcecconi@estraspa.it','ddemartino@estraspa.it'];
        return allowed.includes(store.getters.currentUser.email);
    },
    hasImpersonations: () => {
        const me = store.getters.currentUser;
        return !!(
            me &&
            me.settings &&
            me.settings.impersonate &&
            Object.keys(me.settings.impersonate).length > 0
        );
    },
    getImpersonations: () => {
        const me = store.getters.currentUser;
        if (
            !me ||
            !me.settings ||
            !me.settings.impersonate
        ) {
            return [];
        }
        return me.settings.impersonate||[];
    },
    /**
     * Run the provided function once for every impersonable user.
     * `fn` can be synchronous or return a Promise.
     * The current JWT is automatically swapped in/out for each call
     * so that `fn` is executed as that user.
     *
     * @param {Function} fn    A function that receives (impersonatedUserId) and
     *                         can be async. It should return the result you need.
     * @returns {Promise<Array>} Array of results, in the same order as userIds.
     */
    async runForAllImpersonations(fn) {
        // save the genuine token so we can restore it at the end
        const previousToken = JwtService.getToken();
        const results = [];
        let mainToken = null;
        // if impersonating, we need to restore the original token
        let previousImpersonationId = JwtService.getImpersonatedUserId();
        if( previousImpersonationId) {
            mainToken = JwtService.getMasterToken();
            await store.dispatch("stopImpersonateUser");
        }else{
            mainToken = previousToken;
        }

        for (const user of UserService.getImpersonations()) {
            try {
                // console.log(`Impersonating user`,user);
                const userId = user.user_id;
                // 1. start impersonating → receive short-lived JWT
                const {data} = await ApiService.post("auth/impersonate", {userId});
                JwtService.saveToken(data.access_token);
                ApiService.setHeader(); // refresh axios header

                // 2. run user-supplied code with that identity
                //    works for both sync & async functions
                /* eslint-disable no-await-in-loop */
                const r = await fn(user);
                /* eslint-enable no-await-in-loop */
                results.push(r);
            }catch (e) {
                // 3. if error, push the error to results
                //    so that we can continue with the next user
                // results.push({error: e.response ? e.response.data.errors : e});
                console.error(`Error impersonating user ${user.user_id}:`, e);
            }

            // 3. restore genuine token
            JwtService.saveToken(mainToken);
            ApiService.setHeader();
        }

        // 3. restore genuine token
        // JwtService.saveToken(mainToken);
        // ApiService.setHeader();
        // 4. restore previous impersonation if any
        if (previousImpersonationId) {
            await store.dispatch("startImpersonateUser", previousImpersonationId);
        } else {
            JwtService.saveToken(previousToken);
            ApiService.setHeader();
        }

        return results;
    },
    startImpersonate: (targetUserId) => {
        this.$store.dispatch("startImpersonateUser", targetUserId);
    },
    stopImpersonate: () => {
        this.$store.dispatch("stopImpersonateUser");
    },
};

export default UserService;
